<template>
    <div class="loading">
        <span class="ring"></span>
    </div>
</template>


<script>
export default {
    name: "Loading"
}
</script>


<style scoped lang="scss">
.loading {
    display: block;
    height: 80vh;
    background-color: #edece8;
    opacity: .9;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ring::after {
    z-index: 2;
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 0 auto;
    border-radius: 50%;
    border: 5px solid rgba(17,19,21,.7);
    border-color: rgba(17,19,21,.7) transparent rgba(17,19,21,.7) transparent;
    animation: spin 1.2s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>